import {
  WorkspaceConnectionStatusStatusEnum,
  WorkspaceConnectionsResponse,
  WorkspaceConnectionStatusEnum,
} from 'lib/generated/api'
import { ExternalConnectionsTableRow } from 'types/entities'
import { InvitationStatus, Invitation } from 'types/entities/Invitation'

// TODO: remove Partial<> when Enum is fixed
const statusMap: Partial<
  Record<WorkspaceConnectionStatusStatusEnum, InvitationStatus>
> = {
  PENDING: 'pending',
  APPROVED: 'accepted',
  EXPIRED: 'expired',
}
export type InvitationsMapper = (
  response: WorkspaceConnectionsResponse
) => Omit<WorkspaceConnectionsResponse, 'results'> & { results: Invitation[] }
export const mapToInvitations: InvitationsMapper = response => {
  const { results, ...rest } = response

  return {
    results: results.map(x => ({
      id: x.connectionId as string,
      name: x.invitee?.organizationName || '',
      status: statusMap[x.status] || 'expired',
    })),
    ...rest,
  }
}

export type ExternalConnectionsMapper = (
  response: WorkspaceConnectionsResponse
) => Omit<WorkspaceConnectionsResponse, 'results'> & {
  results: ExternalConnectionsTableRow[]
}
export const mapToExternalConnectionsList: ExternalConnectionsMapper = response => {
  return {
    ...response,
    results: response.results.map(x => ({
      id: x.connectionId,
      organizationName: x.inviter?.organizationName || '',
      workspaceName: x.inviter?.entityLabel || '',
      connectionDate: x.connectedAt as Date,
      status: x.status,
    })),
  }
}
